import { fetchSearchResults as fetchResultsFromPhoenix, FetchSearchResults } from '../../phoenix';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export function fetchSearchResults(args: FetchSearchResults & { referenceId: string }) {
  const { referenceId, ...rest } = args;

  return queryClient.fetchQuery({
    queryFn: () => fetchResultsFromPhoenix(rest),
    queryKey: queryKeys.search(referenceId),
    staleTime: 0,
    gcTime: 0,
  });
}
